// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d855a71b","667":"735d8059","977":"9ccfda1a"}[chunkId] + ".chunk.js";
};